import React from 'react';
import { getText } from 'src/utils/i18n';
import globalStore from 'src/utils/global-data-store';
import eventManager from '@alife/scc-event-manager/event-manager';

export default class MaTags extends React.PureComponent {
  state = {
    isHotTag: -1,
  };

  componentDidMount() {
    const dataPromise = globalStore.get('transactionOverview');
    if (dataPromise) {
      dataPromise.then(res => {
        if (res && res.data) {
          const { totalTransactions, totalQuantities } = res.data;
          if (totalTransactions > 10 || totalQuantities > 1000) {
            this.setState({
              isHotTag: 1,
            });
          }
        }
      });
    }
  }

  render() {
    const { i18n, tradeInfo = {}, hasSPU } = this.props;
    const { orderCntYear } = tradeInfo;
    const showYdtTag = orderCntYear ? orderCntYear.orderCnt > 0 : false;

    const { isHotTag } = this.state;

    return (
      <div className="ma-tag-wrap">
        <span className="promotion-tags" id="detail-title-tags-below-title" />
        {showYdtTag && !hasSPU ? (
          <div
            className="ma-tag ma-tag-orange"
            data-tip="Real activity data from China Customs"
          >
            <a data-domdot="id:27037" target="_blank">
              <i className="ui2-icon ui2-icon-data" />
              {getText(i18n, 'mainAction_ydt_tag', 'Customs Data')}
            </a>
          </div>
        ) : null}
        {/* 展示热卖标签 */}
        <div
          className="ma-tag ma-tag-orange hot-sale-tag hot-sale-tag-1"
          style={{
            display: isHotTag === 1 ? 'inline-block' : 'none',
          }}
          onClick={() => {
            eventManager.trigger('changeDetailTab', 'transactionHistory')
          }}
        >
          {getText(i18n, 'title.hotsale', 'Hot sale products')}
        </div>
        {/* 展示带国家的热卖标签 */}
        <div
          className="ma-tag ma-tag-orange hot-sale-tag hot-sale-tag-2"
          // onClick={() => {
          //   eventManager.trigger('changeListFilterCountry', countryId);
          // }}
          style={{
            display: isHotTag === 2 ? 'inline-block' : 'none',
          }}
        >
          {getText(i18n, 'title.hotsalecountry', 'Hot sale in')}
        </div>
      </div>
    );
  }
}
